<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import { mapGetters, mapActions, mapState } from "vuex";
// import VueApexCharts from 'vue-apexcharts';

/**
 *  dashboard component
 */
export default {
  page: {
    title: "Departmental Performance",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    ModelListSelect,
    // apexchart: VueApexCharts,
  },
  data() {
    return {
      test:[],
      chartselect: {
        data: 'bar',
        department: 'select',
        time: 'all',
        dateRange: 0
      },
      load_status: true,
      items: [
        {
          text: "Departmental Performance",
          href: "/",
        },
        {
          text: "Departmental Performance",
          active: true,
        },
      ],

      timeFilters: [
        { title: "Customise", value: "custom" },     
        { title: "All", value: "all" },
        { title: "Today", value: "today" },
        { title: "Yesterday", value: "yesterday" },
        { title: "Last 7 days", value: "last7" },
        { title: "Last 14 days", value: "last14" },
        { title: "Last 28 days", value: "last28" },
        { title: "This month", value: "month" },
        { title: "This quarter", value: "quarter" },
      ],
      filterData: {
        time: "all",
        dateRange: "",
      },
      graphLabel: "for all time",

      // GRAPH DATA     
      // SERVICE ANALYSIS GRAPH BAR CHART
      columnChart: {
        series: [
          {
            name: "Data",
            data: [0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Departmental Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Departmental Performance analysis',
                },
                png: {
                  filename: 'Departmental Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: false,
              columnWidth: "100%",
            },
          },
          dataLabels: {
            enabled: false,
          },          
            stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#002AFF","#e9f029","#FF0000","#EB8C87","#29f040","#C23829","#18f0e1","#c50ff2","#f20f88","","#556ee6",],
          xaxis: {
            categories: [
              "Consultation",
              "Radiology",
              "Procedure",
              "Laboratory",
              "Dental",
              "Antenantal",
              "Inpatient",
              "Pharmacy",
            ],
          },
          yaxis: {
            title: {
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Shs " + val;
              },
            },
          },
        },
      },

      // PER DEPARTMENT SERVICE ANALYSIS GRAPH BAR CHART
      DepcolumnChart: {
        series: [
          {
            name: "Data",
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ],
        chartOptions: {
          chart: {
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Per-Department Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Per-Department Performance analysis',
                },
                png: {
                  filename: 'Per-Department Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          plotOptions: {
            bar: {
              distributed: true,
              horizontal: false,
              columnWidth: "100%",
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"],
          },
          colors: ["#002AFF","#e9f029","#FF0000","#EB8C87","#29f040","#C23829","#18f0e1","#c50ff2","#f20f88","","#556ee6",],
          xaxis: {
            categories: [
              "---",
              "---",
              "---",
              "---",
              "---",
              "---",
              "---",
              "---",
              "---",
              "---",
            ],
          },
          yaxis: {
            title: {
              style: {
                fontWeight: "500",
              },
            },
          },
          grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Shs " + val;
              },
            },
          },
        },
      },
      DepdonutChart: {
        series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        chartOptions: {
          labels: ['', '', '', '', '', '', '', '','', ''],
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Per-Department Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Per-Department Performance analysis',
                },
                png: {
                  filename: 'Per-Department Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
            grid: {
            borderColor: "#f1f1f1",
          },
          fill: {
            opacity: 1,
          },
          tooltip: {
            y: {
              formatter: function (val) {
                return "Shs " + val;
              },
            },
          },
          },
        },
      },
      donutChart: {
        series: [0, 0, 0, 0, 0, 0, 0, 0],
        chartOptions: {
          labels: ['Consultation', 'Radiology', 'Procedure', 'Laboratory', 'Dental', 'Antenantal', 'Inpatient', 'Pharmacy'],
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Departmental Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Departmental Performance analysis',
                },
                png: {
                  filename: 'Departmental Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
        },
      },
      LineChart: {
        series: [
          {
            name: "Income",
            data: [0,0,0,0,0,0,0,0],
          }
        ],
        chartoptions: {
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Departmental Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Departmental Performance analysis',
                },
                png: {
                  filename: 'Departmental Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          colors: ["#002AFF", "#FF0000"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: [
              "..",
              "..",
              "..",
              "..",
              "..",
              "..",
              "..",
              "..",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
      DepLineChart: {
        series: [
          {
            name: "Data",
            data: [0,0,0,0,0,0,0,0,0,0],
          }
        ],
        chartoptions: {
          chart: {
            height: 350,
            type: "area",
            toolbar: {
              show: true,
              offsetX: 0,
              offsetY: 0,
              tools: {
                download: true,
                selection: true,
                zoom: true,
                zoomin: true,
                zoomout: true,
                pan: true,
                reset: true | '<img src="/static/icons/reset.png" width="20">',
                customIcons: []
              },
              export: {
                csv: {
                  filename: 'Per-Department Performance analysis',
                  columnDelimiter: ',',
                  headerCategory: 'category',
                  headerValue: 'value',
                  dateFormatter(timestamp) {
                    return new Date(timestamp).toDateString()
                  }
                },
                svg: {
                  filename: 'Per-Department Performance analysis',
                },
                png: {
                  filename: 'Per-Department Performance analysis',
                }
              },
              autoSelected: 'zoom' 
            },
          },
          colors: ["#002AFF", "#FF0000"],
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          fill: {
            type: "gradient",
            gradient: {
              shadeIntensity: 1,
              inverseColors: false,
              opacityFrom: 0.45,
              opacityTo: 0.05,
              stops: [20, 100, 100, 100],
            },
          },
          xaxis: {
            categories: [
              "..",
              "..",
              "..",
              "..",
              "..",
              "..",
              "..",
              "..",
              "..",
              "..",
            ],
          },
          markers: {
            size: 3,
            strokeWidth: 3,

            hover: {
              size: 4,
              sizeOffset: 2,
            },
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
          },
        },
      },
    };
  },  
  methods: {
    ...mapActions({
      FetchGraph: "reports/fetchGraph",
      FetchDepartmentGraph: "reports/fetchdepartmentGraph",
    }),
    thousandSeprator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
          .toString()
          .replace(/\D/g, "")
          .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    setLabel() {
      if (this.filterData.time == "today") {
        this.graphLabel = "today";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "yesterday") {
        this.graphLabel = "yesterday";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last7") {
        this.graphLabel = "in last 7 days";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last14") {
        this.graphLabel = "in last 14 days";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "last28") {
        this.graphLabel = "in last 28 days";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "month") {
        this.graphLabel = "in this month";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "quarter") {
        this.graphLabel = "in this quarter";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "all") {
        this.graphLabel = "for all time";
        this.filterData.dateRange = "";
      }
      if (this.filterData.time == "custom") {
        this.graphLabel = "";
        this.filterData.dateRange = "";
      }
    },
    setDepLabel() {
      if (this.chartselect.time == "today") {
        this.graphLabel = "today";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "yesterday") {
        this.graphLabel = "yesterday";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "last7") {
        this.graphLabel = "in last 7 days";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "last14") {
        this.graphLabel = "in last 14 days";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "last28") {
        this.graphLabel = "in last 28 days";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "month") {
        this.graphLabel = "in this month";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "quarter") {
        this.graphLabel = "in this quarter";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "all") {
        this.graphLabel = "for all time";
        this.chartselect.dateRange = "";
      }
      if (this.chartselect.time == "custom") {
        this.graphLabel = "";
        this.chartselect.dateRange = "";
      }
    },

    FilterDash() {
      if (this.filterData.time == "custom" && this.filterData.dateRange == "") {
        return;
      }
      if (
        this.filterData.time == "custom" &&
        this.filterData.dateRange[0] == null &&
        this.filterData.dateRange[1] == null
      ) {
        return;
      }
      this.FetchGraph(this.filterData);
    },

    SetGraph() {
      // LINE GRAPH
      this.columnChart.series[0].data[0] = parseInt(this.graphData.Consultation??0);
      this.columnChart.series[0].data[1] = parseInt(this.graphData.Radiology??0);
      this.columnChart.series[0].data[2] = parseInt(this.graphData.Procedure??0);
      this.columnChart.series[0].data[3] = parseInt(this.graphData.Laboratory??0);
      this.columnChart.series[0].data[4] = parseInt(this.graphData.Dental??0);
      this.columnChart.series[0].data[5] = parseInt(this.graphData.Antenantal??0);
      this.columnChart.series[0].data[6] = parseInt(this.graphData.Inpatient??0);
      this.columnChart.series[0].data[7] = parseInt(this.graphData.Pharmacy??0);


      this.donutChart.series[0] = parseInt(this.graphData.Consultation??0);
      this.donutChart.series[1] = parseInt(this.graphData.Radiology??0);
      this.donutChart.series[2] = parseInt(this.graphData.Procedure??0);
      this.donutChart.series[3] = parseInt(this.graphData.Laboratory??0);
      this.donutChart.series[4] = parseInt(this.graphData.Dental??0);
      this.donutChart.series[5] = parseInt(this.graphData.Antenantal??0);
      this.donutChart.series[6] = parseInt(this.graphData.Inpatient??0);
      this.donutChart.series[7] = parseInt(this.graphData.Pharmacy??0);

      this.LineChart.series[0].data[0] = parseInt(this.graphData.Consultation??0);
      this.LineChart.series[0].data[1] = parseInt(this.graphData.Radiology??0);
      this.LineChart.series[0].data[2] = parseInt(this.graphData.Procedure??0);
      this.LineChart.series[0].data[3] = parseInt(this.graphData.Laboratory??0);
      this.LineChart.series[0].data[4] = parseInt(this.graphData.Dental??0);
      this.LineChart.series[0].data[5] = parseInt(this.graphData.Antenantal??0);
      this.LineChart.series[0].data[6] = parseInt(this.graphData.Inpatient??0);
      this.LineChart.series[0].data[7] = parseInt(this.graphData.Pharmacy??0);


      setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
    },

    //Per department graphs    
    DepartmentCheck(){
      if (this.chartselect.department != 'select' && this.chartselect.time == "custom" && this.chartselect.dateRange == "") {
        return;
      }
      if (
        this.chartselect.department != 'select' &&
        this.chartselect.time == "custom" &&
        this.chartselect.dateRange[0] == null &&
        this.chartselect.dateRange[1] == null
      ) {
        return;
      }
      if(this.chartselect.department != 'select'){
        this.FetchDepartmentGraph(this.chartselect);        
      }      
    }
  },

  computed: {
    ...mapState("reports", ["graphsData"]),
    ...mapGetters("reports", ["graphData"]),
    ...mapGetters("reports", ["DepgraphData"]),
    ...mapGetters("auth", ["user_permissions"]),
  },

  watch: {
    graphsData(newValue) {
      if (newValue) {
        this.SetGraph();
      }
    },
    DepgraphData(newValue) {
      if (newValue) {

        //Department Column Chart
        this.DepcolumnChart.series[0].data[0] = parseInt(this.DepgraphData[0]?this.DepgraphData[0].total:0);
        this.DepcolumnChart.series[0].data[1] = parseInt(this.DepgraphData[1]?this.DepgraphData[1].total:0);
        this.DepcolumnChart.series[0].data[2] = parseInt(this.DepgraphData[2]?this.DepgraphData[2].total:0);
        this.DepcolumnChart.series[0].data[3] = parseInt(this.DepgraphData[3]?this.DepgraphData[3].total:0);
        this.DepcolumnChart.series[0].data[4] = parseInt(this.DepgraphData[4]?this.DepgraphData[4].total:0);
        this.DepcolumnChart.series[0].data[5] = parseInt(this.DepgraphData[5]?this.DepgraphData[5].total:0);
        this.DepcolumnChart.series[0].data[6] = parseInt(this.DepgraphData[6]?this.DepgraphData[6].total:0);
        this.DepcolumnChart.series[0].data[7] = parseInt(this.DepgraphData[7]?this.DepgraphData[7].total:0);
        this.DepcolumnChart.series[0].data[8] = parseInt(this.DepgraphData[8]?this.DepgraphData[8].total:0);
        this.DepcolumnChart.series[0].data[9] = parseInt(this.DepgraphData[9]?this.DepgraphData[9].total:0);

        if(this.chartselect.department == 'Pharmacy'){
          this.DepcolumnChart.chartOptions.xaxis.categories[0] = this.DepgraphData[0]?this.DepgraphData[0].drug:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[1] = this.DepgraphData[1]?this.DepgraphData[1].drug:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[2] = this.DepgraphData[2]?this.DepgraphData[2].drug:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[3] = this.DepgraphData[3]?this.DepgraphData[3].drug:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[4] = this.DepgraphData[4]?this.DepgraphData[4].drug:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[5] = this.DepgraphData[5]?this.DepgraphData[5].drug:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[6] = this.DepgraphData[6]?this.DepgraphData[6].drug:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[7] = this.DepgraphData[7]?this.DepgraphData[7].drug:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[8] = this.DepgraphData[8]?this.DepgraphData[8].drug:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[9] = this.DepgraphData[9]?this.DepgraphData[9].drug:'';
        }else{
          this.DepcolumnChart.chartOptions.xaxis.categories[0] = this.DepgraphData[0]?this.DepgraphData[0].name:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[1] = this.DepgraphData[1]?this.DepgraphData[1].name:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[2] = this.DepgraphData[2]?this.DepgraphData[2].name:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[3] = this.DepgraphData[3]?this.DepgraphData[3].name:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[4] = this.DepgraphData[4]?this.DepgraphData[4].name:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[5] = this.DepgraphData[5]?this.DepgraphData[5].name:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[6] = this.DepgraphData[6]?this.DepgraphData[6].name:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[7] = this.DepgraphData[7]?this.DepgraphData[7].name:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[8] = this.DepgraphData[8]?this.DepgraphData[8].name:'';
          this.DepcolumnChart.chartOptions.xaxis.categories[9] = this.DepgraphData[9]?this.DepgraphData[9].name:'';
        }
        //Department Line Chart
        this.DepLineChart.series[0].data[0] = parseInt(this.DepgraphData[0]?this.DepgraphData[0].total:0);
        this.DepLineChart.series[0].data[1] = parseInt(this.DepgraphData[1]?this.DepgraphData[1].total:0);
        this.DepLineChart.series[0].data[2] = parseInt(this.DepgraphData[2]?this.DepgraphData[2].total:0);
        this.DepLineChart.series[0].data[3] = parseInt(this.DepgraphData[3]?this.DepgraphData[3].total:0);
        this.DepLineChart.series[0].data[4] = parseInt(this.DepgraphData[4]?this.DepgraphData[4].total:0);
        this.DepLineChart.series[0].data[5] = parseInt(this.DepgraphData[5]?this.DepgraphData[5].total:0);
        this.DepLineChart.series[0].data[6] = parseInt(this.DepgraphData[6]?this.DepgraphData[6].total:0);
        this.DepLineChart.series[0].data[7] = parseInt(this.DepgraphData[7]?this.DepgraphData[7].total:0);
        this.DepLineChart.series[0].data[8] = parseInt(this.DepgraphData[8]?this.DepgraphData[8].total:0);
        this.DepLineChart.series[0].data[9] = parseInt(this.DepgraphData[9]?this.DepgraphData[9].total:0);

        if(this.chartselect.department == 'Pharmacy'){
          this.DepLineChart.chartoptions.xaxis.categories[0] = this.DepgraphData[0]?this.DepgraphData[0].drug:'';
          this.DepLineChart.chartoptions.xaxis.categories[1] = this.DepgraphData[1]?this.DepgraphData[1].drug:'';
          this.DepLineChart.chartoptions.xaxis.categories[2] = this.DepgraphData[2]?this.DepgraphData[2].drug:'';
          this.DepLineChart.chartoptions.xaxis.categories[3] = this.DepgraphData[3]?this.DepgraphData[3].drug:'';
          this.DepLineChart.chartoptions.xaxis.categories[4] = this.DepgraphData[4]?this.DepgraphData[4].drug:'';
          this.DepLineChart.chartoptions.xaxis.categories[5] = this.DepgraphData[5]?this.DepgraphData[5].drug:'';
          this.DepLineChart.chartoptions.xaxis.categories[6] = this.DepgraphData[6]?this.DepgraphData[6].drug:'';
          this.DepLineChart.chartoptions.xaxis.categories[7] = this.DepgraphData[7]?this.DepgraphData[7].drug:'';
          this.DepLineChart.chartoptions.xaxis.categories[8] = this.DepgraphData[8]?this.DepgraphData[8].drug:'';
          this.DepLineChart.chartoptions.xaxis.categories[9] = this.DepgraphData[9]?this.DepgraphData[9].drug:'';
        }else{
          this.DepLineChart.chartoptions.xaxis.categories[0] = this.DepgraphData[0]?this.DepgraphData[0].name:'';
          this.DepLineChart.chartoptions.xaxis.categories[1] = this.DepgraphData[1]?this.DepgraphData[1].name:'';
          this.DepLineChart.chartoptions.xaxis.categories[2] = this.DepgraphData[2]?this.DepgraphData[2].name:'';
          this.DepLineChart.chartoptions.xaxis.categories[3] = this.DepgraphData[3]?this.DepgraphData[3].name:'';
          this.DepLineChart.chartoptions.xaxis.categories[4] = this.DepgraphData[4]?this.DepgraphData[4].name:'';
          this.DepLineChart.chartoptions.xaxis.categories[5] = this.DepgraphData[5]?this.DepgraphData[5].name:'';
          this.DepLineChart.chartoptions.xaxis.categories[6] = this.DepgraphData[6]?this.DepgraphData[6].name:'';
          this.DepLineChart.chartoptions.xaxis.categories[7] = this.DepgraphData[7]?this.DepgraphData[7].name:'';
          this.DepLineChart.chartoptions.xaxis.categories[8] = this.DepgraphData[8]?this.DepgraphData[8].name:'';
          this.DepLineChart.chartoptions.xaxis.categories[9] = this.DepgraphData[9]?this.DepgraphData[9].name:'';
        }
        //Department Donut Chart
        this.DepdonutChart.series[0] = parseInt(this.DepgraphData[0]?this.DepgraphData[0].total:0);
        this.DepdonutChart.series[1] = parseInt(this.DepgraphData[1]?this.DepgraphData[1].total:0);
        this.DepdonutChart.series[2] = parseInt(this.DepgraphData[2]?this.DepgraphData[2].total:0);
        this.DepdonutChart.series[3] = parseInt(this.DepgraphData[3]?this.DepgraphData[3].total:0);
        this.DepdonutChart.series[4] = parseInt(this.DepgraphData[4]?this.DepgraphData[4].total:0);
        this.DepdonutChart.series[5] = parseInt(this.DepgraphData[5]?this.DepgraphData[5].total:0);
        this.DepdonutChart.series[6] = parseInt(this.DepgraphData[6]?this.DepgraphData[6].total:0);
        this.DepdonutChart.series[7] = parseInt(this.DepgraphData[7]?this.DepgraphData[7].total:0);
        this.DepdonutChart.series[8] = parseInt(this.DepgraphData[8]?this.DepgraphData[8].total:0);
        this.DepdonutChart.series[9] = parseInt(this.DepgraphData[9]?this.DepgraphData[9].total:0);

        if(this.chartselect.department == 'Pharmacy'){
          this.DepdonutChart.chartOptions.labels[0] = this.DepgraphData[0]?this.DepgraphData[0].drug:'';
          this.DepdonutChart.chartOptions.labels[1] = this.DepgraphData[1]?this.DepgraphData[1].drug:'';
          this.DepdonutChart.chartOptions.labels[2] = this.DepgraphData[2]?this.DepgraphData[2].drug:'';
          this.DepdonutChart.chartOptions.labels[3] = this.DepgraphData[3]?this.DepgraphData[3].drug:'';
          this.DepdonutChart.chartOptions.labels[4] = this.DepgraphData[4]?this.DepgraphData[4].drug:'';
          this.DepdonutChart.chartOptions.labels[5] = this.DepgraphData[5]?this.DepgraphData[5].drug:'';
          this.DepdonutChart.chartOptions.labels[6] = this.DepgraphData[6]?this.DepgraphData[6].drug:'';
          this.DepdonutChart.chartOptions.labels[7] = this.DepgraphData[7]?this.DepgraphData[7].drug:'';
          this.DepdonutChart.chartOptions.labels[8] = this.DepgraphData[8]?this.DepgraphData[8].drug:'';
          this.DepdonutChart.chartOptions.labels[9] = this.DepgraphData[9]?this.DepgraphData[9].drug:'';
        }else{
          this.DepdonutChart.chartOptions.labels[0] = this.DepgraphData[0]?this.DepgraphData[0].name:'';
          this.DepdonutChart.chartOptions.labels[1] = this.DepgraphData[1]?this.DepgraphData[1].name:'';
          this.DepdonutChart.chartOptions.labels[2] = this.DepgraphData[2]?this.DepgraphData[2].name:'';
          this.DepdonutChart.chartOptions.labels[3] = this.DepgraphData[3]?this.DepgraphData[3].name:'';
          this.DepdonutChart.chartOptions.labels[4] = this.DepgraphData[4]?this.DepgraphData[4].name:'';
          this.DepdonutChart.chartOptions.labels[5] = this.DepgraphData[5]?this.DepgraphData[5].name:'';
          this.DepdonutChart.chartOptions.labels[6] = this.DepgraphData[6]?this.DepgraphData[6].name:'';
          this.DepdonutChart.chartOptions.labels[7] = this.DepgraphData[7]?this.DepgraphData[7].name:'';
          this.DepdonutChart.chartOptions.labels[8] = this.DepgraphData[8]?this.DepgraphData[8].name:'';
          this.DepdonutChart.chartOptions.labels[9] = this.DepgraphData[9]?this.DepgraphData[9].name:'';
        }
        setTimeout(function () {
        window.dispatchEvent(new Event("resize"));
      }, 100);
      }
    },
  },

  created() {
    this.FetchGraph(this.filterData);
    this.SetGraph();
  },
};
</script>
<style scoped>
.spinner-grow {
  width: 1000px;
  height: 0;
}
</style>

<template>
  <Layout>
    <PageHeader title="Departmental Performance" />
    
    <div>
      <div class="card">
        <div class="card-body">
          <div class="row justify-content-end"> 
            <div class="col-md-3 mt-4" v-if="chartselect.time != 'custom'"> 
              <router-link to="/reports/departmental_performance_table"><button class="btn btn-success mr-2"><i class="fa fa-list"></i> Tabular View</button></router-link>
            </div>          
            <div class="col-md-3">
              <label for="">Select Department</label>
              <select class="form-control" @change="DepartmentCheck(); setDepLabel();" v-model="chartselect.department">
                <option value="select">All departments</option>
                <option value="Consultation">Consultation</option>
                <option value="Radiology">Radiology</option>
                <option value="Procedure">Procedure</option>
                <option value="Laboratory">Laboratory</option>
                <option value="Dental">Dental</option>
                <option value="Antenantal">Antenantal</option>
                <option value="Inpatient">Inpatient</option>
                <option value="Pharmacy">Pharmacy</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="">Select Chart type</label>
              <select class="form-control" v-model="chartselect.data">
                <option value="all">All Charts</option>
                <option value="bar">Bar Chart</option>
                <option value="donut">Donut Chart</option>
                <option value="line">Line Chart</option>
              </select>
            </div>
            <div v-if="chartselect.department == 'select'" class="col-md-3">
              <label for="">Select time frame</label>
              <model-list-select
                :list="this.timeFilters ? this.timeFilters : []"
                v-model="filterData.time"
                option-value="value"
                size="sm"
                @input="                  
                  FilterDash();
                  setLabel();
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>
            <div v-else class="col-md-3">
              <label for="">Select time frame</label>
              <model-list-select
                :list="this.timeFilters ? this.timeFilters : []"
                v-model="chartselect.time"
                option-value="value"
                size="sm"
                @input="
                  DepartmentCheck();
                  setDepLabel();                  
                "
                option-text="title"
                placeholder="Select Time-frame"
              >
              </model-list-select>
            </div>
            <div v-if="chartselect.department == 'select' && filterData.time == 'custom'" class="col-md-2">
              <date-picker
                v-model="filterData.dateRange"
                range
                append-to-body
                @change="FilterDash"
                lang="en"
                confirm
              ></date-picker>
            </div>
            <div v-if="chartselect.department != 'select' && chartselect.time == 'custom'" class="col-md-2">
              <date-picker
                v-model="chartselect.dateRange"
                range
                append-to-body
                @change="DepartmentCheck"
                lang="en"
                confirm
              ></date-picker>
            </div>     
          </div>
        </div>
      </div>
      <!-- end row -->

      <div class="row" v-if="user_permissions.sales_graph == 1 && chartselect.department == 'select' && chartselect.data == 'donut' || chartselect.data == 'all' && chartselect.department == 'select'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Services Sale Pie Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="donut"
                :series="donutChart.series"
                :options="donutChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="row" v-if="user_permissions.sales_graph == 1 && chartselect.department == 'select' && chartselect.data == 'bar' || chartselect.data == 'all' && chartselect.department == 'select'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">Services Sale Bar Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="columnChart.series"
                :options="columnChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>        
        <div class="row" v-if="user_permissions.sales_graph == 1 && chartselect.department == 'select' && chartselect.data == 'line' || chartselect.data == 'all' && chartselect.department == 'select'">
        <template>
          <div class="card">
            <div class="card-body">
            
              <h4 class="card-title mb-4">Services Sale Line Chart Report {{ graphLabel }}</h4>
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="350"
                  :series="LineChart.series"
                  :options="LineChart.chartoptions"
                ></apexchart>
            </div>
          </div>
        </template>
        </div>

        <div class="row" v-if="user_permissions.sales_graph == 1 && chartselect.department != 'select' && chartselect.data == 'donut' || chartselect.data == 'all' && chartselect.department != 'select'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">{{chartselect.department}} Services Sale Pie Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="donut"
                :series="DepdonutChart.series"
                :options="DepdonutChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        <div class="row" v-if="user_permissions.sales_graph == 1 && chartselect.department != 'select' && chartselect.data == 'bar' || chartselect.data == 'all' && chartselect.department != 'select'">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4">{{chartselect.department}} Services Sale Bar Chart Report {{ graphLabel }}</h4>
              <apexchart
                class="apex-charts"
                height="350"
                type="bar"
                dir="ltr"
                :series="DepcolumnChart.series"
                :options="DepcolumnChart.chartOptions"
              ></apexchart>
            </div>
          </div>
        </div>
        
        <div class="row" v-if="user_permissions.sales_graph == 1 && chartselect.department != 'select' && chartselect.data == 'line' || chartselect.data == 'all' && chartselect.department != 'select'">
        <template>
          <div class="card">
            <div class="card-body">
            
              <h4 class="card-title mb-4">{{chartselect.department}} Services Sale Line Chart Report {{ graphLabel }}</h4>
                <apexchart
                  class="apex-charts"
                  dir="ltr"
                  height="350"
                  :series="DepLineChart.series"
                  :options="DepLineChart.chartoptions"
                ></apexchart>
            </div>
          </div>
        </template>
        </div>
      <!-- end col -->
    </div>
  </Layout>
</template>
